"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FiftyFiftyLayout = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
var _imageSizesHelper = require("@ori/image-sizes-helper");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _utils = require("../../utils");
var _shared = require("../shared");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const FiftyFiftyLayout = (param)=>{
    let { banner, debug, modulePosition, className } = param;
    const { title, contentAlignment, backgroundImage, backgroundVideo, backgroundType, link, steps, storybookColor } = banner;
    const { getTestId } = (0, _testidGenerator.default)();
    const isMobile = (0, _presentationHooks.useIsMobile)();
    const imageUrl = isMobile ? backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.urlMobile : backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.url;
    const imagesVariants = (0, _react.useMemo)(()=>imageUrl ? {
            url: imageUrl,
            imageSizeMultiplier: 2,
            imageFormat: 'WebP',
            params: _constants.IMAGE_PARAMS.params
        } : null, [
        imageUrl
    ]);
    if (steps.length === 0 || !backgroundImage && !backgroundVideo) {
        return (0, _utils.getModulesContentError)({
            debug,
            modulePosition,
            layout: _constants.FIFTY_LAYOUT_NAME
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.FIFTY_LAYOUT_ROOT),
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.ContentWrapper, {
                storybookColor: storybookColor,
                contentAlignment: contentAlignment,
                children: [
                    title ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Title, {
                        "data-testid": getTestId(_constants.FIFTY_LAYOUT_TITLE),
                        variant: "h4",
                        children: title
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.InnerContent, {
                        children: steps.map((step)=>{
                            var _step_content;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.TextWithCaption, {
                                children: [
                                    (step === null || step === void 0 ? void 0 : step.caption) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Caption, {
                                        "data-testid": getTestId(_constants.FIFTY_LAYOUT_CAPTION),
                                        variant: "body1",
                                        children: step.caption
                                    }) : null,
                                    step === null || step === void 0 ? void 0 : (_step_content = step.content) === null || _step_content === void 0 ? void 0 : _step_content.map((text)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.StyledTextWithHtml, {
                                            isOverflowVisible: true,
                                            html: text === null || text === void 0 ? void 0 : text.text,
                                            testId: getTestId(_constants.FIFTY_LAYOUT_TEXT)
                                        }, text === null || text === void 0 ? void 0 : text.text))
                                ]
                            }, step === null || step === void 0 ? void 0 : step.caption);
                        })
                    }),
                    (link === null || link === void 0 ? void 0 : link.relativeUrl) && link.title ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.Button, {
                        link: {
                            relativeUrl: link.relativeUrl,
                            title: link.title
                        }
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.MediaWrapper, {
                "data-testid": getTestId(_constants.FIFTY_LAYOUT_MEDIA),
                children: [
                    backgroundType === _editorialFetching.BackgroundType.Image && imageUrl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        srcSet: (0, _imageSizesHelper.generateSrcSet)((0, _imageSizesHelper.getImageVariants)(imagesVariants)),
                        alt: title !== null && title !== void 0 ? title : '',
                        sizes: _constants.IMAGE_PARAMS.sizes
                    }) : null,
                    backgroundType === _editorialFetching.BackgroundType.Video && (backgroundVideo === null || backgroundVideo === void 0 ? void 0 : backgroundVideo.id) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.VideoLayout, {
                        banner: {
                            __typename: 'EditorialBanner',
                            modules: [
                                {
                                    backgroundStorybookColor: storybookColor,
                                    backgroundType,
                                    backgroundVideo: {
                                        ...backgroundVideo
                                    }
                                }
                            ],
                            layout: _editorialFetching.EditorialBannerLayoutEnum.FiftyBanner
                        },
                        modulePosition: modulePosition,
                        debug: debug,
                        isStandaloneVideo: false
                    }) : null
                ]
            })
        ]
    });
};
exports.FiftyFiftyLayout = FiftyFiftyLayout;
